// extracted by mini-css-extract-plugin
module.exports = {"moviesGrid":"movieGrid_moviesGrid__1cVqn"};